import React from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import './styles.css'

export default (props) => {

    const handleDecline = () => {
        props.setShow(false)
    }

    return(
        <div>
            <Dialog
                open={props.showModal} 
                aria-labelledby="draggable-dialog-title" 
                maxWidth='sm'
            >
                <DialogContent>
                    <h2 id='modal-title'className='modal-pj-title'>{props.title}</h2> <br/><br/>

                    <div className='modal-confirm-textt'>
                        <p id='modal-text'className='ctsss'>{props.text}</p>
                    </div>
                    <br/><br/>
                    <div className='modal-confirm-buttonss2'>
                        <button id='close-button' className='modal-confirm-buttons1 stl-nw-clr' onClick={handleDecline}>
                            Fechar
                        </button>
                        {/* <button className='modal-confirm-buttons1 btn-cnf' onClick={handleConfirm}>
                            Sim, confirmar
                        </button> */}
                    </div>
                    <br/>
                </DialogContent>
            </Dialog>
        </div>
    )
}